import request from '@/utils/request'

export const myCommonOpinions = (operationType, approvalType) => request({
  url: '/workOrder/myCommonOpinions', method: 'get', params: { operationType, approvalType }, silent: true
})
